import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import { InputV2 } from '@bridebook/ui';
import { RsvpQuestionFormValues } from '@bridebook/web/lib/rsvp/types';
import { useTranslation } from 'next-i18next';
import styles from '@bridebook/web/components/wedding-website/rsvp/question-form/sections/question-field.style';

interface IProps {
  control: Control<RsvpQuestionFormValues>;
  error?: string;
}

export const QuestionField: FC<IProps> = ({ control, error }) => {
  const { t } = useTranslation('weddingWebsite');

  return (
    <Controller
      name="question"
      control={control}
      render={({ field }) => (
        <InputV2
          required
          style={styles.input}
          placeholder={t('rsvp.form.question.placeholder')}
          {...field}
          error={error}
        />
      )}
    />
  );
};
